import axios from "axios"
import {
    CALCULATION_FAILED,
    CALCULATION_FINISHED,
    CALCULATION_SUCCESS,
    CHANGE_PAGE, CURRENT_LOCATION, CURRENT_LOCATION_ERROR,
    CURRENT_LOCATION_SUCCESS,
    GET_EVENTS,
    GET_EVENTS_ERROR,
    GET_EVENTS_SUCCESS,
    SEND_EVENT,
    SEND_EVENT_ERROR,
    SEND_EVENT_SUCCESS,
    START_CALCULATION
} from "../constants/constants";
import {guidGenerator} from "../../utils/Helpers";

const BASE_URL = "https://api-tum-leitfaden.com"
const EVENTS_URL = "https://gtqrlr5u4bf3lur5gkcarjvqsu0qucyc.lambda-url.eu-central-1.on.aws/"

export const changePage = (number: number) => (dispatch: any): any => {
    dispatch({
        type: CHANGE_PAGE,
        payload: number
    })
}

export const sendDataToBackend = (data: any) => async (dispatch: any): Promise<any> => {
    dispatch({
        type: START_CALCULATION,
        payload: data
    })
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
    }
    axios.post(BASE_URL + "/process", data, {headers: headers} as any).then(response => {
        dispatch({
            type: CALCULATION_SUCCESS,
            payload: response.data
        })
    }).catch(err => {
        dispatch({
            type: CALCULATION_FAILED,
            payload: JSON.stringify(err)
        })
    })
}
export const resetCalculation = () => async (dispatch: any): Promise<any> => {
    dispatch({
        type: CALCULATION_FINISHED
    })
}
export const sendEventsData = (data: any) => async (dispatch: any): Promise<any> => {
    dispatch({
        type: SEND_EVENT
    })
    let clientId;
    if (localStorage.getItem("digitaler_leitfaden_clientId")) {
        clientId = localStorage.getItem("digitaler_leitfaden_clientId")
    } else {
        clientId = guidGenerator();
        localStorage.setItem("digitaler_leitfaden_clientId", clientId)
    }
    data.clientId = clientId;
    axios.post(EVENTS_URL, data).then(response => {
        dispatch({
            type: SEND_EVENT_SUCCESS,
            payload: response.data
        })
    }).catch(err => {
        dispatch({
            type: SEND_EVENT_ERROR,
            payload: JSON.stringify(err)
        })
    })
}
export const getUserLocation = () => async (dispatch:any) :Promise<any>=>{
    dispatch({
        type: CURRENT_LOCATION
    })
    axios.get('https://ipapi.co/json/').then(response =>{
        dispatch({
            type: CURRENT_LOCATION_SUCCESS,
            payload: response.data
        })
    }).catch(err =>{
        dispatch({
            type:CURRENT_LOCATION_ERROR,
            payload: err
        })
    })
}

export const sendUserLocation = () => async (dispatch: any): Promise<any> => {
    let response = await axios.get('https://ipapi.co/json/')
    let coordinates = response.data

    let clientId;
    if (localStorage.getItem("digitaler_leitfaden_clientId")) {
        clientId = localStorage.getItem("digitaler_leitfaden_clientId")
    } else {
        clientId = guidGenerator();
        localStorage.setItem("digitaler_leitfaden_clientId", clientId)
    }
    axios.post(EVENTS_URL, {
        clientId: clientId,
        date: new Date().toLocaleString(),
        timestamp: new Date().getTime(),
        value: coordinates.city,
        type: "city"
    }).then(response => {
        dispatch({
            type: SEND_EVENT_SUCCESS,
            payload: response.data
        })
    }).catch(err => {
        dispatch({
            type: SEND_EVENT_ERROR,
            payload: JSON.stringify(err)
        })
    })
    axios.post(EVENTS_URL, {
        clientId: clientId,
        date: new Date().toLocaleString(),
        timestamp: new Date().getTime(),
        value: coordinates.country,
        type: "country"
    }).then(response => {
        dispatch({
            type: SEND_EVENT_SUCCESS,
            payload: response.data
        })
    }).catch(err => {
        dispatch({
            type: SEND_EVENT_ERROR,
            payload: JSON.stringify(err)
        })
    })

}


export const getEventsData = () => async (dispatch: any): Promise<any> => {
    dispatch({
        type: GET_EVENTS
    })
    axios.get(EVENTS_URL).then(response => {
        dispatch({
            type: GET_EVENTS_SUCCESS,
            payload: response.data
        })
    }).catch(err => {
        dispatch({
            type: GET_EVENTS_ERROR,
            payload: JSON.stringify(err)
        })
    })
}
